import React, { useState, useEffect } from 'react';
import { 
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend 
} from 'recharts';
import { 
    Building, Clock, TrendingUp, Filter, Loader2 
} from 'lucide-react';
import api from '../services/api'; // Sua API Local

const formatDuration = (seconds) => {
    if (!seconds || isNaN(seconds)) return '00:00:00';
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
};

const RelatoriosEmpresasScreen = ({ currentUser }) => { 
    const getLocalYYYYMMDD = (d) => {
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    
    // Filtros
    const [startDate, setStartDate] = useState(getLocalYYYYMMDD(firstDay));
    const [endDate, setEndDate] = useState(getLocalYYYYMMDD(today));
    
    // Dados
    const [reportData, setReportData] = useState([]);
    const [metrics, setMetrics] = useState({
        total: 0, ended: 0, canceled: 0, avgTime: 0, list: []
    });
    const [loading, setLoading] = useState(false);

    // Buscar Relatório da API Local
    const fetchReportData = async () => {
        setLoading(true);
        try {
            // MUDANÇA AQUI: Rota específica de Empresas
            const response = await api.get('/reports/companies', {
                params: { startDate, endDate }
            });

            setMetrics(response.data.metrics || { total: 0, list: [] });
            setReportData(response.data.chartData || []);

        } catch (error) {
            console.error("Erro ao gerar relatório:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReportData();
    }, [startDate, endDate]);

    return (
        <div className="p-6 h-full overflow-y-auto bg-gray-50">
            <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
                <div>
                    <h2 className="text-2xl font-bold text-gray-800 flex items-center">
                        <Building className="mr-2 text-blue-600" /> Relatório por Empresas
                    </h2>
                    <p className="text-sm text-gray-500">Volume de atendimentos agrupado por cliente corporativo</p>
                </div>

                <div className="flex gap-2 items-center bg-white p-2 rounded-lg shadow-sm border border-gray-200">
                    <Filter className="w-4 h-4 text-gray-500" />
                    <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className="p-1.5 border rounded text-sm"/>
                    <span className="text-gray-400">-</span>
                    <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className="p-1.5 border rounded text-sm"/>
                    <button onClick={fetchReportData} className="p-1.5 bg-blue-100 text-blue-700 rounded hover:bg-blue-200">
                        {loading ? <Loader2 className="w-4 h-4 animate-spin"/> : <TrendingUp className="w-4 h-4"/>}
                    </button>
                </div>
            </div>

            {/* GRÁFICO */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 mb-8">
                <h3 className="font-bold text-gray-700 mb-4">Top 10 Empresas (Volume)</h3>
                <div className="h-80">
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={reportData}>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} />
                            <XAxis dataKey="name" tick={{fontSize: 10}} interval={0} angle={-15} textAnchor="end" />
                            <YAxis />
                            <Tooltip />
                            <Bar dataKey="total" name="Total" fill="#8884d8" radius={[4, 4, 0, 0]} />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>

            {/* TABELA */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                <table className="w-full text-sm text-left">
                    <thead className="bg-gray-50 border-b uppercase text-xs text-gray-500">
                        <tr>
                            <th className="px-6 py-3">Empresa</th>
                            <th className="px-6 py-3 text-center">Total</th>
                            <th className="px-6 py-3 text-center">Finalizados</th>
                            <th className="px-6 py-3 text-center">T.M.A</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {metrics.list && metrics.list.length > 0 ? (
                            metrics.list.map((item, idx) => (
                                <tr key={idx} className="hover:bg-gray-50">
                                    <td className="px-6 py-4 font-bold text-gray-700">{item.name}</td>
                                    <td className="px-6 py-4 text-center font-bold">{item.total}</td>
                                    <td className="px-6 py-4 text-center text-green-600">{item.ended}</td>
                                    <td className="px-6 py-4 text-center text-gray-500">{formatDuration(item.tma)}</td>
                                </tr>
                            ))
                        ) : (
                            <tr><td colSpan="4" className="text-center py-8 text-gray-400">Sem dados.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default RelatoriosEmpresasScreen;